import { render, staticRenderFns } from "./sidebar-link.vue?vue&type=template&id=6bff28f0&"
import script from "./sidebar-link.vue?vue&type=script&lang=js&"
export * from "./sidebar-link.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-link.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports